import { render, staticRenderFns } from "./DataListCategories.vue?vue&type=template&id=74f523a0&scoped=true&"
import script from "./DataListCategories.vue?vue&type=script&lang=js&"
export * from "./DataListCategories.vue?vue&type=script&lang=js&"
import style0 from "./DataListCategories.vue?vue&type=style&index=0&id=74f523a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f523a0",
  null
  
)

export default component.exports